<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.724 49.9727C110.214 47.4835 114.249 47.4835 116.739 49.9727C119.228 52.4619 119.228 56.4976 116.739 58.9868L98.4497 77.2757C95.9605 79.7649 91.9247 79.7649 89.4355 77.2757C86.9463 74.7865 86.9463 70.7507 89.4355 68.2615L107.724 49.9727Z"
    />
    <path
      d="M41.1891 34.0185C36.5029 29.3322 28.9049 29.3322 24.2186 34.0185C19.5323 38.7048 19.5323 46.3028 24.2186 50.989L51.0804 77.8508C55.7667 82.5371 63.3646 82.5371 68.0509 77.8508C72.7372 73.1645 72.7372 65.5666 68.0509 60.8803L41.1891 34.0185Z"
    />
    <path
      d="M27.8844 20.7138C27.2324 20.0618 26.1753 20.0618 25.5233 20.7138C21.489 24.748 21.489 31.2889 25.5233 35.3232L57.8083 67.6082C60.1514 69.9513 63.9504 69.9513 66.2936 67.6082C68.6367 65.265 68.6367 61.4661 66.2936 59.1229L27.8844 20.7138Z"
    />
    <path
      d="M4.93246 53.4786C3.273 55.138 3.273 57.8285 4.93246 59.488L7.93718 62.4927C14.575 69.1306 25.3371 69.1306 31.975 62.4927L44.8966 49.5711C48.2156 46.2521 48.2156 40.8711 44.8966 37.5522L38.8872 31.5427C35.5683 28.2238 30.1872 28.2238 26.8683 31.5427L4.93246 53.4786Z"
    />
    <path
      d="M98.2662 89.3977C106.043 89.3977 112.348 83.0932 112.348 75.3163C112.348 64.3185 103.432 55.4031 92.4345 55.4031H61.3558C51.9685 55.4031 44.3585 63.0131 44.3585 72.4004C44.3585 81.7878 51.9685 89.3977 61.3558 89.3977H98.2662Z"
    />
    <path
      d="M105.976 108.979C107.12 113.247 111.506 115.779 115.774 114.636C120.042 113.492 122.574 109.106 121.431 104.838L110.647 64.5909C109.503 60.3232 105.117 57.7905 100.849 58.9341C96.5811 60.0776 94.0484 64.4643 95.1919 68.732L105.976 108.979Z"
    />
    <path
      d="M105.976 108.979C107.12 113.247 111.506 115.779 115.774 114.636C120.042 113.492 122.574 109.106 121.431 104.838L119.36 97.1105L103.906 101.252L105.976 108.979Z"
      fill="#CB80DE"
    />
    <path
      d="M60.356 106.894C60.356 111.312 56.7742 114.894 52.356 114.894C47.9377 114.894 44.356 111.312 44.356 106.894L44.356 71.9017C44.356 67.4834 47.9377 63.9017 52.356 63.9017C56.7742 63.9017 60.356 67.4834 60.356 71.9017L60.356 106.894Z"
    />
    <path
      d="M60.356 106.894C60.356 111.312 56.7742 114.894 52.356 114.894C47.9377 114.894 44.356 111.312 44.356 106.894L44.356 98.8936L60.356 98.8936L60.356 106.894Z"
      fill="#CB80DE"
    />
    <path
      d="M58.1071 50.7227C59.7666 49.0633 62.4571 49.0633 64.1165 50.7227C65.776 52.3822 65.776 55.0727 64.1165 56.7322L47.6525 73.1962C45.9931 74.8557 43.3026 74.8557 41.6431 73.1962C39.9836 71.5367 39.9836 68.8462 41.6431 67.1867L58.1071 50.7227Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'DogInsurance'
  }
</script>
